module.exports = __webpack_public_path__ + "img/host.29446dd1.svg";